<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<h4>{{translate(locale.addNewAdministrator)}}</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="!loaded">
			<md-card>
				<md-card-content>
					<loading />
				</md-card-content>
			</md-card>
		</div>

		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="loaded">
			<md-card>
				<md-card-content>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100 text-right">
							<span class="late">{{translate(locale.required)}}</span>
						</div>

						<div
							class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-40 md-size-40">
							<md-field>
								<label>{{translate(locale.singleId)}} *</label>
								<md-input type="text" v-model="user.id"></md-input>
							</md-field>
						</div>
						<div
							class="md-layout-item md-xsmall-size-100 md-small-size-70 md-medium-size-40 md-size-40">
							<md-field>
								<label>{{translate(locale.userRole)}} *</label>
								<md-select :placeholder="translate(locale.userRole) + ' *'" v-model="user.role">
									<md-option value="user">{{translate(locale.roleUser)}}</md-option>
									<md-option
										value="super-admin">{{translate(locale.roleSuperAdmin)}}</md-option>
								</md-select>
							</md-field>
						</div>
						<div
							class="md-layout-item md-xsmall-size-100 md-small-size-30 md-medium-size-20 md-size-20 text-right">
							<md-button class="md-raised md-primary" style="width: 100%"
								@click="searchUser()">{{translate(locale.searchUser)}}</md-button>
						</div>

						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" v-if="search.valid">
							<md-table>
								<md-table-row>
									<md-table-cell style="width: 30%;">{{translate(locale.singleIdCode)}}</md-table-cell>
									<md-table-cell style="width: 5px">:</md-table-cell>
									<md-table-cell><b>{{search.id || "N/A"}}</b></md-table-cell>
								</md-table-row>
								<md-table-row>
									<md-table-cell style="width: 30%;">{{translate(locale.personal_code)}}</md-table-cell>
									<md-table-cell style="width: 5px">:</md-table-cell>
									<md-table-cell><b>{{search.personal_code || "N/A"}}</b></md-table-cell>
								</md-table-row>
								<md-table-row>
									<md-table-cell style="width: 30%;">{{translate(locale.government_id)}}</md-table-cell>
									<md-table-cell style="width: 5px">:</md-table-cell>
									<md-table-cell><b>{{search.government_id || "N/A"}}</b></md-table-cell>
								</md-table-row>
								<md-table-row>
									<md-table-cell style="width: 30%;">{{translate(locale.userSingleName)}}</md-table-cell>
									<md-table-cell style="width: 5px">:</md-table-cell>
									<md-table-cell><b>{{search.last_name_km}} {{search.first_name_km}}</b></md-table-cell>
								</md-table-row>
								<md-table-row>
									<md-table-cell style="width: 30%;">{{translate(locale.phone_number)}}</md-table-cell>
									<md-table-cell style="width: 5px">:</md-table-cell>
									<md-table-cell><b>+{{search.phone_number || "N/A"}}</b></md-table-cell>
								</md-table-row>
								<md-table-row>
									<md-table-cell style="width: 30%;">{{translate(locale.email)}}</md-table-cell>
									<md-table-cell style="width: 5px">:</md-table-cell>
									<md-table-cell><b>{{search.email || "N/A"}}</b></md-table-cell>
								</md-table-row>
							</md-table>
						</div>
						<div class="md-layout-item md-size-100 text-right">
							<span v-for="e in errors" style="color: red">* {{translate(e)}}<br></span>
						</div>
						<div
							class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
							<md-button class="md-raised md-primary"
								@click="createUser()">{{translate(locale.addNewAdministrator)}}</md-button>
						</div>
					</div>

				</md-card-content>
			</md-card>
		</div>
	</div>

	</div>

</template>

<script>
	import Editor from '@tinymce/tinymce-vue';
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime, Editor },
		created() {
			// this.getSettings();
		},

		data() {
			return {
				loaded: true,
				user: {
					id: "",
					role: ""
				},
				search: {
					valid: false,
					id: "",
					personal_code: "",
					government_id: "",
					first_name_km: "",
					last_name_km: "",
					phone_number: "",
					email: ""
				},
				errors: []
			}
		},
		methods: {
			searchUser() {

				this.$http.post(this.config.api + "/admin/admin/search_user", {
					id: this.user.id
				}).then(res => {
					if (res.body.status == 'success') {
						this.search.id = res.body.data.user.id;
						this.search.personal_code = res.body.data.user.personal_code;
						this.search.government_id = res.body.data.user.government_id;
						this.search.first_name_km = res.body.data.user.first_name_km;
						this.search.last_name_km = res.body.data.user.last_name_km;
						this.search.phone_number = res.body.data.user.phone_number;
						this.search.email = res.body.data.user.email;
						this.search.valid = true;
					}
				})
			},
			createUser() {

				if (!this.checkValidation()) {
					return;
				}

				this.$http.post(this.config.api + "/admin/admin/post", {
					user: this.user
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have created an account successfully.||អ្នកបានបង្កើតគណនីគ្រប់គ្រងដោយជោគជ័យ។",
							icon: 'check_circle',
							type: 'success'
						});

						this.$router.push("/administrators");
					}
				})
			},
			checkValidation() {
				this.errors = [];

				if (String(this.user.role).length <= 0) this.errors.push("Please fill in Role.||សូមបំពេញតួនាទី។");


				if (this.errors.length == 0) return true;
				else return false;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/Administrators/New.vue